<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Feedback zu den Mahlzeiten</h1>
                <p class="h2">...und erhalten Tipps, wie sie ihre Essgewohnheiten verbessern können</p>
            </div>
            <div class="right-wrapper">
                <h2>Markierung des Essens</h2>
                <p class="text">Die Nutzenden fotografieren und beschriften ihr Essen und die Vitadio-App gibt ihnen automatisch Feedback. Diese tägliche Interaktion unterstützt nachhaltig bei der Entwicklung gesünderer Essgewohnheiten.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 14
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

